import { useQuery } from "@tanstack/react-query";
import { getNotifications } from "../services/medias.service";
import { QueryKeys } from "./queryKeys";

export function useNotificationsByStore(
  storeId: string | undefined,
  countryId: string
) {
  return useQuery({
    queryKey: [QueryKeys.Notifications, storeId],
    queryFn: () => getNotifications(storeId || "", countryId),
    enabled: !!storeId,
    staleTime: 1000 * 60 * 5, // 5 minutes stale time
  });
}
